import {
  SearchParamsPetCounts,
  SearchParamsPetType,
} from '@rover/constants/src/translations/sitterProfilePage.constants';
import { CountryConfigurationUrls } from '@rover/rsdk/src/apiClient/latest/model/countryConfigurationUrls';
import { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';
import { useCurrentCountryConfiguration } from '@rover/rsdk/src/modules/Data/Core/CountryConfiguration';
import { PetType } from '@rover/types/src/Pet';
import { PriceTransparencyLevel } from '@rover/types/src/PriceTransparencyLevel';
import {
  getIsPriceTransparencyCondensed,
  getIsPriceTransparencyFull,
} from '@rover/utilities/priceTransparency';

import { usePrimaryPetType } from '../utils/utils';

import { isSitterInPetCareModesExperiment } from './isSitterInPetCareModesExperiment';
import { useRevampProfileContext } from './useRevampProfileContext';

type RevampCtaData = {
  countryConfigUrls: CountryConfigurationUrls | undefined;
  isPetCareModes: boolean;
  isPtFull: boolean;
  isPtCondensed: boolean;
  displayPetType: PetType;
  price: string | null | undefined;
};

export const useRevampCtaCommon = (
  priceTransparencyLevel: PriceTransparencyLevel,
  petType: SearchParamsPetType,
  petCount: SearchParamsPetCounts,
  standardRate: EnhancedPersonSitterProfile['services'][number]['serviceAddOns'][number] | undefined
): RevampCtaData => {
  const { sitterData } = useRevampProfileContext();
  const { urls: countryConfigUrls } = useCurrentCountryConfiguration();
  const isPetCareModes = isSitterInPetCareModesExperiment(sitterData);

  const isPtFull = getIsPriceTransparencyFull(priceTransparencyLevel);

  const price = isPtFull ? standardRate?.fullPricePerUnit : standardRate?.pricePerUnit;

  const isPtCondensed = getIsPriceTransparencyCondensed(priceTransparencyLevel);

  const displayPetType = usePrimaryPetType(petCount, petType, sitterData.services);

  return { countryConfigUrls, isPetCareModes, isPtFull, isPtCondensed, displayPetType, price };
};
